import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import moment from 'moment'
import { extendObservable, action } from 'mobx'
import enhanceWithClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'
import DateRangeIcon from '@material-ui/icons/DateRange'
import MonthYearCalendar from '@components/MonthPicker/MonthYearCalendar'
import HonorariaAnalysisMobile from './HonorariaAnalysisMobile'

import { formatNoDecimalBigInt, formatDecimal } from '@atheneum/api/dist/lib'

import WidgetBox from '../WidgetBox'

class HonorariaAnalysis extends Component {
  static propTypes = {
    dashboardStore: PropTypes.object,
    honorariaAnalysis: PropTypes.object,
    activeTeamId: PropTypes.number,
    setDate: PropTypes.func,
    date: PropTypes.string
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      isCalendarShown: false
    })

    this.datePicker = null
  }

  handleCalendarDisplay = () => {
    this.isCalendarShown = true
  }

  handleClickOutside = () => {
    this.closeCalendar()
  }

  closeCalendar = () => {
    this.isCalendarShown = false
  }

  handleDateChange = action(date => {
    const { getHonorariaAnalysisWidgetData } = this.props.dashboardStore
    this.props.setDate(date)
    const newDate = moment(date).format('MM-YYYY')
    !this.props.activeTeamId
      ? getHonorariaAnalysisWidgetData(newDate)
      : getHonorariaAnalysisWidgetData(newDate, this.props.activeTeamId)
  })

  onMonthPress = monthAndYear => {
    this.isCalendarShown = false
    this.handleDateChange(monthAndYear)
  }

  render() {
    const { getSortedTeamMembers } = this.props.dashboardStore

    if (!this.props.honorariaAnalysis) return null
    const date = this.props.date
    return (
      <WidgetBox
        label="Honoraria Analysis"
        action={
          <div>
            <div className="widget-box__top-bar__action--opacity">
              <button
                readOnly
                className="honorariaAnalysis-widget__datepicker"
                onClick={this.handleCalendarDisplay}>
                <DateRangeIcon />
                <div className="datepicker-text">{date}</div>
              </button>
            </div>
          </div>
        }>
        <div className="mobile-honorariaAnalysis">
          <HonorariaAnalysisMobile
            teamMembers={getSortedTeamMembers(
              this.props.honorariaAnalysis.teamMembers
            )}
          />
        </div>
        <div className="desktop-honorariaAnalysis">
          <div className="honorariaAnalysis-widget">
            {this.props.honorariaAnalysis.teamName && (
              <div className="team-name-manager-section">
                <div>Team {this.props.honorariaAnalysis.teamName}</div>
              </div>
            )}
            <div className="honorariaAnalysis-table-row top-total-row">
              <div className="honorariaAnalysis-table-cell">Name</div>
              <div className="honorariaAnalysis-table-cell">Position</div>
              <div className="honorariaAnalysis-table-cell">Avg €</div>
              <div className="honorariaAnalysis-table-cell">Diff. %</div>
            </div>
            <div className="team-list">
              {getSortedTeamMembers(
                this.props.honorariaAnalysis.teamMembers
              ).map((teamMember, index) => {
                return teamMember.fullName ? (
                  <div className="honorariaAnalysis-table-row" key={index}>
                    <div className="honorariaAnalysis-table-cell">
                      {teamMember.fullName}
                    </div>
                    <div className="honorariaAnalysis-table-cell">
                      {teamMember.is_senior ? 'Senior ' : ''}
                      {teamMember.position}
                    </div>
                    <div className="honorariaAnalysis-table-cell">
                      {formatNoDecimalBigInt(teamMember.average)}
                    </div>
                    <div
                      className={`honorariaAnalysis-table-cell ${
                        teamMember.diff > 0 ? 'diff-positive' : 'diff-negative'
                      }`}>
                      {formatDecimal(teamMember.diff)}
                    </div>
                  </div>
                ) : null
              })}
            </div>
          </div>
        </div>
        {this.isCalendarShown && (
          <MonthYearCalendar
            closeCalendar={this.closeCalendar}
            activeMonthAndYear={date}
            onMonthPress={this.onMonthPress}
          />
        )}
      </WidgetBox>
    )
  }
}

export default inject(
  'userStore',
  'dashboardStore'
)(enhanceWithClickOutside(observer(HonorariaAnalysis)))
